var icon = require('vue-svgicon')
icon.register({
  'ks-icon-info': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M59.8 51.4h8.4V43h-8.4M64 97.6A33.6 33.6 0 1 1 97.6 64 33.65 33.65 0 0 1 64 97.6M64 22a42 42 0 1 0 42 42 42 42 0 0 0-42-42m-4.2 63h8.4V59.8h-8.4z"/>'
  }
})
